<div class="container-fluid">
  <header>
    <app-nav-menu></app-nav-menu>
  </header>

  <main role="main" class="backg">
    <div class="container-fluid ">
      <div class="row">
        <div class="col-sm-12 col-md-6 left_content">
          <div class="left_con">
            <h2 class=" welcome1message">Welcome to PATEMPO!</h2>
            <p class="mt-4 text-left text-secondary welcome2message">PATEMPO™ responds to a critical question that any patent applicant or agent has: “Assuming I can obtain a patent, how long will it take to get granted?”. It allows to automatically estimate the pendency of your patent applications in China and South-East Asia and to instantly access to our recommendations on how to expedite their examination, publication and grant.</p>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 right_content">
          <div class="right_con">
            <form #form='ngForm' class="mb-4" autocomplete="off" (submit)="onSubmit(form)">
              <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#fff" type="ball-spin-clockwise-fade" [fullScreen]="false"></ngx-spinner>
              <div class="row">
                <div class="col-12 text-left ">
                  <h3 class="text-secondary loginTitle"><strong>Log In</strong></h3>
                </div>
                <div class="col-12 mt-4">
                  <input class="form-control-lg emailAddress" #UserName="ngModel" name="UserName" [(ngModel)]="formModel.UserName" required placeholder="Email address">
                </div>
                <div class="col-12 mt-3">
                  <input type="password" class="form-control-lg password" #Password="ngModel" name="Password" [(ngModel)]="formModel.Password" required autocomplete="off" placeholder="Password">
                </div>
                <div class="col-12 mt-4 text-right" align="right">
                  <a href="#" [routerLink]="['/forgot-password']" class="text-info text_dont forgot-password">Forgot Password?</a>
                </div>
                <div class="col-12 mt-5">
                  <button type="submit" class="text-center w-100 btn-login text-white login-button">LOGIN</button>
                </div>
                <div class="col-12 mt-4 text-center text_dont reminderMessageContent" align="center">
                  Don't have an account? <a class="sign-up" [routerLink]="['/registration']">SIGN UP</a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </main>

  <div class="LoginFooter">
    <footer>
      <patempoFooter></patempoFooter>
    </footer>
  </div>
  
</div>
